'use client'

import {
  ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ZAxis,
} from 'recharts'
import type { ScatterPayload } from '../svs-types'
import { resolveColor } from '../color-mapping'

interface ScatterRendererProps {
  payload: ScatterPayload
}

export function ScatterRenderer({ payload }: ScatterRendererProps) {
  const { series } = payload.data
  const options = payload.options || {}
  const showLegend = series.length > 1
  const hasBubble = series.some(s => s.points.some(p => p.size != null))

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ScatterChart margin={{ top: 10, right: 20, left: 10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis type="number" dataKey="x" name="x" label={options.xLabel ? { value: options.xLabel, position: 'insideBottom', offset: -5 } : undefined} />
        <YAxis type="number" dataKey="y" name="y" label={options.yLabel ? { value: options.yLabel, angle: -90, position: 'insideLeft' } : undefined} />
        {hasBubble && <ZAxis type="number" dataKey="size" range={[40, 400]} />}
        <Tooltip cursor={{ strokeDasharray: '3 3' }} />
        {showLegend && <Legend />}
        {series.map((s, si) => {
          const color = resolveColor(s.color, si)
          return (
            <Scatter
              key={s.name || si}
              name={s.name || `Series ${si + 1}`}
              data={s.points}
              fill={color}
            />
          )
        })}
      </ScatterChart>
    </ResponsiveContainer>
  )
}
